import gql from 'graphql-tag';

export default gql`
  query merchandiseSpotBanner {
    application(name: DESKTOPBOOKINGPATH) {
      ... on DesktopBookingPath {
        merchandiseSpotBanner {
          desktopImage {
            image
            alternateText
          }
          responsiveImage {
            image
            alternateText
          }
          clickThrough {
            url
            title
            target
          }
        }
      }
    }
  }
`;
